import { faDash } from '@fortawesome/pro-thin-svg-icons';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { twMerge } from 'tailwind-merge';

interface EmptyDataProps extends Omit<FontAwesomeIconProps, 'icon'> {}
const EmptyData = (props: EmptyDataProps) => {
    const { className, ...rest } = props;

    return (
        <FontAwesomeIcon className={twMerge('text-gray-400', className)} icon={faDash} {...rest} />
    );
};

export { EmptyData };
